import { Component, OnInit, OnDestroy } from '@angular/core';
import { success } from 'toastr';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Login } from '../../entidade/login/login';
import { UsuarioService } from '../../usuario/service/usuario.service';
import { LoginService } from '../servico/login.service';
import { Router } from '@angular/router';
import { GlobalService } from '../../util/global.service';
import { FuncaoService } from '../../util/funcao.service';

@Component({
  selector: 'lib-trocar-senha',
  templateUrl: './trocar-senha.component.html'
})
export class TrocarSenhaComponent implements OnInit, OnDestroy {

  public login: Login = new Login();
  public senhaAtual: string;
  public senhaNova: string;
  public mensagemErro: string;
  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected router: Router,
    private usuarioService: UsuarioService,
    private loginService: LoginService,
    private funcaoservice: FuncaoService
  ) {
  }

  ngOnInit() {
    this.login = GlobalService.obterSessaoLogin();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public async enviar() {
    this.mensagemErro = null;

    if (!this.senhaAtual) {
      this.mensagemErro = 'Informe a senha atual.';
      return;
    }

    const usuario = await this.usuarioService.obter({ relations: 'usuario_estoques,usuario_estoques.estoque,usuario_setores.setor,orgao', id: this.login.usuario.id }).toPromise()
    
    let erros = [];
    let errosNaoPode = [];

    if (!this.senhaNova || this.senhaNova.length < 6) {
      erros.push('no mínimo 6 caracteres');
    }

    const regexCaracterEspecial = /[@#$%&*!]/;
    if (!this.senhaNova || !regexCaracterEspecial.test(this.senhaNova)) {
      erros.push('ao menos 1 caractere especial (@#$%&*!)');
    }

    if (this.senhaNova) {
      const senhaLower = this.senhaNova.toLowerCase();
      if ((usuario.sobrenome && usuario.sobrenome.toLocaleLowerCase().includes(senhaLower)) || 
          (usuario.nome && senhaLower === usuario.nome.toLowerCase())) {
        errosNaoPode.push('ser igual ao nome/sobrenome do usuário');
      }

      const sequenciaNumeros = '012345678909876543210';
      if (sequenciaNumeros.includes(this.senhaNova)) {
        errosNaoPode.push('conter sequências numéricas padrões, ex: (1234,4321)');
      }

      if (usuario.cpf && this.senhaNova === usuario.cpf.replace(/[^\d]+/g, '')) {
        errosNaoPode.push('ser igual ao CPF/CNPJ do usuário');
      }
    }

    if (erros.length > 0 || errosNaoPode.length > 0) {
      let mensagem = '';
      if (erros.length > 0) {
        mensagem += 'A nova senha deve conter ' + erros.join(' e ') + '. ';
      }
      if (errosNaoPode.length > 0) {
        mensagem += 'Não pode ' + errosNaoPode.join(', nem ') + '.';
      }
      this.mensagemErro = mensagem.trim();
      return;
    }

    usuario.senha = this.senhaAtual
    usuario.senha_nova = this.senhaNova
    this.usuarioService.trocarSenha(usuario).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        success('Senha foi alterada com sucesso!');
        this.login.usuario.orgao = this.login.orgao;
        ($('#dialogTrocarSenha') as any).modal('hide');
        this.loginService.desconectar(this.login.usuario);
      }, (error) => {
        this.funcaoservice.acaoErro(error)
      });
    this.senhaAtual = null;
    this.senhaNova = null;
  }

}
